<template>
  <div
    class="RelationCard mr-8 mb-8"
    :class="`RelationCard--${nodeState}`"
  >
    <div class="PersonCardHeader d-flex">
      <div style="width: 100%;">
        <v-row>
          <svg class="avatar rounded">
            <SvgImage :type="type" />
          </svg>
          <div class="details">
            <h2 class="h-2-bold label">{{ internalLabel }}</h2>
            <h3 class="h-5 sublabel">
              {{ sublabel }}
            </h3>
          </div>
        </v-row>
        <v-row>
          <div class="content">
            <CompletionBlock
              class="mb-10 mt-16"
              :completion="completion"
            />
            <div class="d-flex justify-center">
              <v-btn
                block
                text
                :class="{ 'app-button-error': validationError }"
                class="theme-btn app-button-primary color nice-padding"
                @click="callParentMethod"
              >{{ $t('common.action.display-infos') }}</v-btn>
            </div>
          </div>
        </v-row>
      </div>
    </div>
  </div>
</template>

<script>
  import SvgImage from '@/components/common/SvgImage/SvgImage'
  import CompletionBlock from '@/components/common/RelationCard/CompletionBlock'
  import { NODE_STATES } from '@/components/common/RelationCard/RelationCard.const'

  export default {
    components: {
      SvgImage,
      CompletionBlock,
    },
    props: {
      validationError: {
        type: Boolean,
        default: true,
      },
      firstName: {
        type: String,
        default: null,
      },
      lastName: {
        type: String,
        default: null,
      },
      sublabel: {
        type: String,
        required: true,
      },
      lastUpdate: {
        type: [Date, String,],
        required: true,
      },
      type: {
        type: String,
        required: true,
      },
      completion: {
        type: Number,
        required: true,
      },
      nodeState: {
        type: String,
        default: NODE_STATES.normal,
      },
    },
    computed: {
      internalLabel() {
        if (this.firstName === null || this.lastName === null) {
          return this.$t('common.not_specified')
        } else {
          return `${this.firstName} ${this.lastName}`
        }
      },
    },
    methods: {
      callParentMethod() {
        this.$emit('click')
      },
    },
  }
</script>

<style scoped lang="scss">
.RelationCard {
  padding: 32px;
  background: #fff;
  width: 27.5em;
  border-radius: 8px;
  box-shadow: 0 2px 4px 0 rgb(31 54 139 / 8%);
  z-index: $zIndexCard;
  text {
    user-select: none;
    alignment-baseline: hanging;
  }
  &--current {
    border: 2px solid $color-009ee0;
  }

  .PersonCardHeader {
    .avatar {
      flex: 0 0 56px;
      width: 56px;
      height: 56px;
      margin-right: 16px;
    }
    .content {
      width: 100%;
    }
    .lastUpdate {
      max-width: 70%;
      color: $color-102d69;
      text-transform: uppercase;
      letter-spacing: 0.32px;
      font-weight: 500;
      font-size: 0.8rem;
      border: 1px solid rgba(0, 28, 75, 0.08);
      background: rgba(0, 28, 75, 0.04);
      padding: 2px 8.5px;
    }
    .label {
      color: $color-001c4b;
      font-size: 1.4rem;
    }
    .sublabel {
      color: $color-9e9fa2;
      font-weight: 500;
      font-size: 0.9rem;
      text-transform: uppercase;
    }
  }
}
</style>
